import ethBase from "./base"
import {ethers} from "ethers";
import config from "@/config";

let storeFactoryContract
let storeFactoryWithSigner

function init(){
    if (!storeFactoryContract || !storeFactoryWithSigner) {
        const {provider, signer} = ethBase.getEthProviderAndSigner()

        storeFactoryContract = new ethers.Contract(
            config.blockchainConfig.contractAddresses.storeFactory,
            config.contractAbi.storeFactory,
            provider
        )

        storeFactoryWithSigner = storeFactoryContract.connect(signer)
    }
}

async function createStore(nftName, nftSymbol) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const tx = await storeFactoryWithSigner.createStore(nftName, nftSymbol);
    return await tx.wait()
}

async function createPurchasable(price, maxSupply, nftMetadataUrl) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const paymentCoinAmount = ethers.utils.parseUnits(price, config.commonConfig.paymentCoinDecimal)
    const tx = await storeFactoryWithSigner.createPurchasable(paymentCoinAmount, parseInt(maxSupply), nftMetadataUrl);
    return await tx.wait()
}

async function createRedeemable(scoreAmount, initialSupply, copiesNumber, ipfsUrl) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const tx = await storeFactoryWithSigner.createRedeemable(
        scoreAmount,
        initialSupply,
        copiesNumber,
        ipfsUrl
    );
    return await tx.wait()
}

async function redeem(storeAccount, redeemableId, amount) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const tx = await storeFactoryWithSigner.redeem(
        storeAccount,
        redeemableId,
        amount
    );
    return await tx.wait()
}

async function storePayment(storeAccount, amount, memo) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const tx = await storeFactoryWithSigner.storePayment(
        storeAccount,
        amount,
        memo
    );
    return await tx.wait()
}

async function buyPurchasable(storeAccount, purchasableId, amount) {
    if (!storeFactoryWithSigner) {
        init()
    }
    const tx = await storeFactoryWithSigner.buyPurchasable(
        storeAccount,
        purchasableId,
        amount
    );
    return await tx.wait()
}

async function getCustomerRewardScore(storeAccount, customerAccount) {
    if(!storeFactoryContract) {
        init()
    }
    return await storeFactoryContract.rewardScore(storeAccount, customerAccount)
}

async function getCustomerSpending(storeAccount, customerAccount) {
    if(!storeFactoryContract) {
        init()
    }
    return await storeFactoryContract.spending(storeAccount, customerAccount)
}


export default {
    createStore,
    createPurchasable,
    createRedeemable,
    storePayment,
    redeem,
    buyPurchasable,
    getCustomerRewardScore,
    getCustomerSpending
}